import React, { useState, useEffect } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import { ContentBox, ContentBoxHead, ContentBoxBody, getCMSObject, CMSContent, IfLoggedIn, ErrorBoundary, TeleScript } from 'sg-ui-components';
import { connect } from 'react-redux';
import { mapDispatchToProps, mapStateToProps } from '../../Store';

import DrawTicketForm from './DrawTicketForm';
import ScratchTicketForm from './ScratchTicketForm';
import promotionConfig from '../../promotionConfig';

/**********************************************************************
 * Component:  EnterTicketTabs
 * Purpose:    Simple tabbed component for Draw/Scratch and or
 *             other ticket types.
 *
 *             Will NOT show if user is not logged in.
 *
 * Props:       none
 *
 * APIs used:   none
 *
 *  Notes:
 */
const EnterTicketTabs = ({ user, cmsSourceFirebase, page, config }) => {
    const [activeTab, setActiveTab] = useState('scratch');
    const enterTicketTeleScript = getCMSObject('data.components.teleScripts.enterTickets.jsonBlock');
    useEffect(() => {
        return () => {
            setActiveTab('scratch');
        };
    }, []);

    return (
        <IfLoggedIn user={user}>
            <div className='enter-tickets-area'>
                <ContentBox variant='theme-primary'>
                    <ContentBoxHead>Enter Tickets</ContentBoxHead>
                    <ContentBoxBody>
                        <CMSContent
                            localStorageObject='webContent'
                            contentPath='data.webNotices'
                            className=''
                            noticePlacement='web-notice-ticket-entry'
                            cmsSourceFirebase={cmsSourceFirebase}
                            delayToShow={1000}>
                            <Tabs defaultActiveKey='scratch' id='enterTicketTabs' activeKey={activeTab} onSelect={(tab) => setActiveTab(tab)} justify>
                                {promotionConfig.drawFields ? (
                                    <Tab eventKey='draw' title={enterTicketTeleScript?.drawTixTabName ?? 'Draw Games'}>
                                        <ErrorBoundary
                                            fallback={<TeleScript line={enterTicketTeleScript?.drawFallback} />}
                                            details={{ page, user, config, ticketType: 'draw' }}>
                                            <DrawTicketForm />
                                        </ErrorBoundary>
                                    </Tab>
                                ) : null}
                                {promotionConfig.scratchTicketFields ? (
                                    <Tab eventKey='scratch' title={enterTicketTeleScript?.instantTixTabName ?? 'Scratchers'}>
                                        <ErrorBoundary
                                            fallback={<TeleScript line={enterTicketTeleScript?.scratchFallback} />}
                                            details={{ page, user, config, ticketType: 'scratch' }}>
                                            <ScratchTicketForm />
                                        </ErrorBoundary>
                                    </Tab>
                                ) : null}
                            </Tabs>
                        </CMSContent>
                    </ContentBoxBody>
                </ContentBox>
            </div>
        </IfLoggedIn>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(EnterTicketTabs);
